/**
 * @generated SignedSource<<9ee68fc6555e347c4970703c4b36ce1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RuleSubruleCreateInputObject = {
  destinationAccountName?: string | null | undefined;
  destinationBankAccountId?: string | null | undefined;
  matchKind?: string | null | undefined;
  parentRuleId: string;
  perspectiveId?: string | null | undefined;
  priority?: number | null | undefined;
  stakeholderId?: string | null | undefined;
  valuePattern: string;
};
export type ruleDetailPage_SubruleCreateMutation$variables = {
  input: RuleSubruleCreateInputObject;
};
export type ruleDetailPage_SubruleCreateMutation$data = {
  readonly ruleSubruleCreate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ruleDetailPage_SubruleCreateMutation = {
  response: ruleDetailPage_SubruleCreateMutation$data;
  variables: ruleDetailPage_SubruleCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleDetailPage_SubruleCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleSubruleCreateMutationPayload",
        "kind": "LinkedField",
        "name": "ruleSubruleCreate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleDetailPage_SubruleCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleSubruleCreateMutationPayload",
        "kind": "LinkedField",
        "name": "ruleSubruleCreate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e444ad7046cd0be1071ce99befdda298",
    "id": null,
    "metadata": {},
    "name": "ruleDetailPage_SubruleCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ruleDetailPage_SubruleCreateMutation(\n  $input: RuleSubruleCreateInputObject!\n) {\n  ruleSubruleCreate(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dec4429cbbc5bf6e45ff59622a15e754";

export default node;
